export interface RichTextRun {
  text: string;
  bold: boolean;
  italic: boolean;
}

const INLINE_MARKUP = /\*\*(.+?)\*\*|\*(.+?)\*/g;

const parseInline = (line: string): RichTextRun[] => {
  const runs: RichTextRun[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  INLINE_MARKUP.lastIndex = 0;
  while ((match = INLINE_MARKUP.exec(line)) !== null) {
    if (match.index > lastIndex) {
      runs.push({ text: line.slice(lastIndex, match.index), bold: false, italic: false });
    }
    if (match[1] !== undefined) {
      runs.push({ text: match[1], bold: true, italic: false });
    } else {
      runs.push({ text: match[2], bold: false, italic: true });
    }
    lastIndex = INLINE_MARKUP.lastIndex;
  }
  if (lastIndex < line.length) {
    runs.push({ text: line.slice(lastIndex), bold: false, italic: false });
  }

  return runs;
};

/**
 * Parses a small, backward-compatible markup subset used for event_detail:
 * **bold**, *italic*, and literal newlines for line breaks. Plain text with
 * none of these markers (the existing data shape) parses back to itself.
 */
export const parseRichText = (raw?: string | null): RichTextRun[][] => {
  if (!raw) return [];
  return raw.split("\n").map(parseInline);
};
